import React from 'react';
import PropTypes from 'prop-types';
import ScrollableWiresList from './scrollable-wires-list';

export default function MentionedWires({ contributorId, contributorName, isScrollable }) {
  return (
    <ScrollableWiresList
      contributorId={contributorId}
      contributorName={contributorName}
      isScrollable={isScrollable}
      type="mentions"
    />
  );
}

MentionedWires.propTypes = {
  contributorId: PropTypes.number.isRequired,
  contributorName: PropTypes.string.isRequired,
  isScrollable: PropTypes.bool,
};

MentionedWires.defaultProps = {
  isScrollable: false,
};
